import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'react-flexbox-grid';
import { prop, propEq, compose, join, filter, isNil, complement, map, take } from 'ramda';

import { createSummaryTile } from '../containers/SummaryLoaderContainer';
import TileRow from './TileRow';

import { path } from 'routes/Documents/routes/Benefits';
import icon from '../assets/benefits.svg';

const opt = o => (o ? `benefits.opts.${o}` : null);

const condensedStr = compose(join(', '), filter(complement(isNil)));

const View = ({ data, localeMessage }) => (
  <Grid fluid>
    {map(d => (
      <div key={d.documentId}>
        {prop('disabilityBenefit', d) && (
          <TileRow title={localeMessage('benefits.labels.disabilityBenefit')}>
            <p className="bold">
              {condensedStr([
                localeMessage(opt(prop('disabilityBenefit', d))),
                propEq('disabilityBenefit', 'yes', d) ? localeMessage(opt(prop('disabilityBenefitLevel', d))) : null,
              ])}
            </p>
          </TileRow>
        )}
        {prop('careBenefit', d) && (
          <TileRow title={localeMessage('benefits.labels.careBenefit')}>
            <p className="bold">
              {condensedStr([
                localeMessage(opt(prop('careBenefit', d))),
                propEq('careBenefit', 'yes', d) ? localeMessage(opt(prop('careBenefitLevel', d))) : null,
              ])}
            </p>
          </TileRow>
        )}
        {prop('personalAssistance', d) && (
          <TileRow title={localeMessage('benefits.labels.personalAssistance')}>
            <p className="bold">{localeMessage(opt(prop('personalAssistance', d)))}</p>
          </TileRow>
        )}
      </div>
    ))(take(1, data))}
  </Grid>
);

View.propTypes = {
  localeMessage: PropTypes.func.isRequired,
  data: PropTypes.array,
};

export default createSummaryTile(View, { module: 'benefits', localeId: 'benefits.title', routeTo: path, icon });
